import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HeaderBar from '../../components/HeaderBar';
import TablePage from './TablePage';
import HistogramBrokenLine from './HistogramBrokenLine';
import { genModules, genSubAuth } from '../../constants';

const Icons = [{ icon: '\ue659', order: 0, key: 'table' }, { icon: '\ue651', order: 1, key: 'histogram' }];

class RequestSheet extends Component {
    static contextTypes = {
        businessList: PropTypes.array,
        clientHeight: PropTypes.number
    }

    constructor(props) {
        super(props);
        const { auth } = props;
        this.icons = genModules(Icons, auth);
        this.state = {
            current: 0,
            searchParams: {
                sort:"grossAmount"
            },
        };
    }

    handleIconChange = (current) => {
        this.setState({ current });
    }

    handleChange = (searchParams) => {
        this.setState({ searchParams: {...searchParams} });
    }

    render() {
        const { businessList, clientHeight } = this.context;
        const { current, searchParams } = this.state;
        const { auth } = this.props;
        return (
            <div className="pane-item">
                <HeaderBar
                    title="请款报表"
                    onChange={this.handleIconChange}
                    current={current}
                    icons={this.icons}
                />
                {
                    current === 0 &&
                    <TablePage
                        searchParams={searchParams}
                        clientHeight={clientHeight}
                        businessList={businessList}
                        onChange={this.handleChange}
                    />
                }
                {
                    current === 1 &&
                    genSubAuth(auth, 'histogram') &&
                    <HistogramBrokenLine
                        searchParams={searchParams}
                        clientHeight={clientHeight}
                    />
                }
            </div>
        );
    }
}

export default RequestSheet;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestAndReturnedSheet/RequestSheet/index.js